import { render } from "./seriesList.vue?vue&type=template&id=0d7f8051&scoped=true"
import script from "./seriesList.vue?vue&type=script&lang=js"
export * from "./seriesList.vue?vue&type=script&lang=js"

import "./seriesList.vue?vue&type=style&index=0&id=0d7f8051&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7f8051"]])

export default __exports__